import $ from 'jquery';

export function padTo2Digits(num) {
    return num.toString().padStart(2, '0');
  }
  
export function formatDate(date) {
    return [
      padTo2Digits(date.getMonth() + 1),
      padTo2Digits(date.getDate()),
      date.getFullYear(),
    ].join('/');
  }

  export function check_length(data,component,required){
    if(data.length>0||required==="yes"){
      if(data.length<=0){$("#"+component).html("Cannot be empty");return false;}else{$("#"+component).html("");return true;}
    }else{
      $("#"+component).html("");
    }
  }

  export function check_letters_only(data,component,required){
    if(data.length>0||required==="yes"){
      if (typeof data !== "undefined"&&data.length>0) {
        if (!data.match(/^[a-zA-Z\s]*$/)) {
          $("#"+component).html("Only letters");
          return false;
        }else{
          $("#"+component).html("");
          return true;
        }
      }
    }else{
      $("#"+component).html("");
    }
  }

  export function check_numbers_only(data,component,required){
    if(data.length>0||required==="yes"){
      if (typeof data !== "undefined"&&data.length>0) {
        if (!data.match(/^[0-9]+$/)) {
          $("#"+component).html("Only Numbers");
          return false;
        }
      }
    }else{
      $("#"+component).html("");
    }
  }

  export function check_date_format(data,component,required){
    if(data.length>0||required==="yes"){
      if(data===null){
        $("#"+component).html("Insert Birthdate");
        return false;
      }else{
        var date_regex = /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/;
        if (!(date_regex.test(formatDate(data)))) {
          $("#"+component).html("Incorrect format");
          return false;
        }else{
          $("#"+component).html("");
        }
      }
    }else{
      $("#"+component).html("");
    }
  }

  export function check_email_format(data,component,required){
    if(data.length>0||required==="yes"){
      if (typeof data !== "undefined"&&data.length>0) {
        if (!data.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/)) {
          $("#"+component).html("Invalid email format");
          return false;
        }
      }
    }else{
      $("#"+component).html("");
    }
  }
  export function check_phone_number(data,component,required){
    if(data.length>0||required==="yes"){
      if(data.length!==10){
        $("#"+component).html("Insert 10 digits phone number format");
        return false;
      }else{
        $("#"+component).html("");
      }
      if (typeof data !== "undefined"&&data.length>0) {
        if (!data.match(/^[0-9]+$/)) {
          $("#"+component).html("Only Numbers");
          return false;
        }
      }
    }else{
      $("#"+component).html("");
    }
  }

  export function getFormattedDate(date1) {
    
    const date = new Date(date1);
    alert(date)
    let year = date.getFullYear();
    let month = (1 + date.getMonth()).toString().padStart(2, '0');
    let day = date.getDate().toString().padStart(2, '0');
  
    return month + '/' + day + '/' + year;
}

export function getAge(dateString) 
{
    var today = new Date();
    var birthDate = new Date(dateString);
    var age = today.getFullYear() - birthDate.getFullYear();
    var m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) 
    {
        age--;
    }
    return age;
}